import React, { useState } from 'react'
import { Checkbox, Col, Panel, Row, Table } from 'rsuite'
import InputForm from '../../components/forms/input/InputForm'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import { Controller, useForm } from 'react-hook-form'
import notification from '../../utils/notification'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import pathname from '../../constants/pathname'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import { cloneDeep, isEmpty } from 'lodash-es'
import { DEFAULT_ERR_MSG, PROCESS_SUCCESS_MSG } from '../../constants/msgText'
import {
  GetAssessmentMAndESelfSummarySearch,
  SendAssessmentMAndESelfNoti,
} from '../../redux/actions/assessment'
import InputSelectForm from '../../components/forms/input/InputSelectForm'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'

export default function MAndESelfProjectSummaryWidgets({ schema: _schema, ...props }) {
  const history = useHistory()

  const { Column, HeaderCell, Cell, ColumnGroup } = Table
  const { register, handleSubmit, errors, control, setValue, reset, clearErrors } = useForm()

  const [formSchema, setFormSchema] = useState(_schema)
  const [isRefash, setIsRefash] = useState(false)
  const [datas, setData] = useState(formSchema.values || [])
  const [totalSize, setTotalSize] = useState(formSchema.totalSize || 0)
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [loading, setLoading] = useState()
  const [request, setRequest] = useState({
    pageNum: 1,
    pageSize: displayLength,
  })

  const [selected, setSelected] = useState()

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  const handleSearch = async (req) => {
    setLoading(true)
    try {
      // console.log('req : ', req)

      const response = await GetAssessmentMAndESelfSummarySearch(req)

      // console.log('response ', response)

      if (response?.length > 0) {
        setData(response || [])
        setTotalSize(response[0].totalSize || 0)
        // notification.open('success', {
        //   title: SAVE_SUCCESS_MSG,
        //   duration: 5000,
        // })
        onRefash()
      } else {
        setData([])
        setTotalSize(0)
        onRefash()
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setLoading(false)
  }

  const handleSendNoti = async (req) => {
    setLoading(true)
    try {
      // console.log('req : ', req)

      const response = await SendAssessmentMAndESelfNoti(req)

      // console.log('response ', response)

      if (response) {
        setSelected([])

        const searchResult = await GetAssessmentMAndESelfSummarySearch(request)
        if (searchResult?.length > 0) {
          setData(searchResult || [])
          setTotalSize(searchResult[0].totalSize || 0)
          onRefash()
        }

        notification.open('success', {
          title: PROCESS_SUCCESS_MSG,
          duration: 5000,
        })
      } else {
        setData([])
        setTotalSize(0)
        onRefash()
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setLoading(false)
  }

  const onSubmit = (data) => {
    // console.log('onSubmit:', data)

    let req = {
      projectCode: data?.projectCode,
      projectName: data?.projectName,
      notiStatus: data?.notiStatus,
      pageNum: 1,
      pageSize: displayLength,
    }

    setPage(1)
    setRequest(req)
    handleSearch(req)
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  const handleChangePage = (dataKey) => {
    // console.log('handleChangePage page', dataKey)

    setPage(dataKey)

    let req = cloneDeep(request)

    req['pageNum'] = dataKey

    setRequest(req)
    handleSearch(req)
  }

  const handleChangeLength = (dataKey) => {
    // console.log('handleChangeLength dataKey', dataKey)
    setPage(1)
    setDisplayLength(dataKey)

    let req = cloneDeep(request)
    req['pageNum'] = 1
    req['pageSize'] = dataKey

    setRequest(req)
    handleSearch(req)
  }

  const onSelected = (rowData, checked) => {
    let emails = []

    if (selected?.projectCode == rowData._parent.projectCode) {
      emails = selected.emails
    }

    if (checked) {
      emails.push(rowData.assessorEmail)
    } else {
      let index = emails?.indexOf(rowData.assessorEmail)
      if (index > -1) {
        emails.splice(index, 1)
      }
    }

    setSelected({
      projectCode: rowData._parent.projectCode,
      emails: emails,
    })
  }

  return (
    <Panel
      bordered
      // key={data.id}
      style={{ marginBottom: 10, marginTop: 10 }}
      collapsible
      defaultExpanded
      header={formSchema.header}
    >
      {loading && <OverlayLoader />}

      <Panel bordered style={{ marginBottom: 10, marginTop: -10 }} header={'ค้นหา'}>
        <Row style={{ marginTop: -10 }}>
          <Col lg={12} md={12} sm={24} xs={24}>
            <InputForm
              schema={formSchema.projectCode}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              value={request.projectCode}
              onChange={(value) => {
                var req = cloneDeep(request)
                req['projectCode'] = value
                setRequest(req)
              }}
            />
          </Col>
          <Col lg={12} md={12} sm={24} xs={24}>
            <InputForm
              schema={formSchema.projectName}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              value={request.projectName}
              onChange={(value) => {
                var req = cloneDeep(request)
                req['projectName'] = value
                setRequest(req)
              }}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Col lg={12} md={12} sm={24} xs={24}>
            <InputSelectForm
              schema={formSchema.notiStatus}
              searchable={false}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              value={request.notiStatus}
              onChange={(value) => {
                var req = cloneDeep(request)
                req['notiStatus'] = value
                setRequest(req)
              }}
            />
          </Col>
        </Row>
        <hr />
        <Row style={{ textAlign: 'right' }}>
          <Col lg={24} md={24} sm={24} xs={24}>
            <SaveButton
              children="คันหา"
              icon="search"
              onClick={handleSubmit(onSubmit)}
              disabled={loading}
            />

            <CancelButton
              children="ยกเลิก"
              onClick={() => {
                // setValue('projectCode', '')
                // setValue('projectName', '')
                onSubmit()
              }}
            />
          </Col>
        </Row>
      </Panel>

      {!isRefash && (
        <>
          <Table
            wordWrap
            isTree
            defaultExpandAllRows
            rowKey="id"
            // height={400}
            autoHeight
            data={datas || []}
            // onExpandChange={(isOpen, rowData) => {
            //   console.log(isOpen, rowData)
            // }}
            renderTreeToggle={(icon, rowData) => {
              if (rowData.children && rowData.children.length === 0) {
                return ' ' //<Icon icon="caret-right" />
              }
              return icon
            }}
            rowClassName={(rowData) => {
              if (!rowData) return ''
              if (rowData.isChild) return 'row-child'
              return ''
            }}
            onRowClick={(rowData) => {
              if (rowData.isChild && isEmpty(rowData.sendDate)) {
                let checked =
                  selected?.projectCode == rowData._parent.projectCode &&
                  selected?.emails?.includes(rowData.assessorEmail)

                onSelected(rowData, !checked)
              }
            }}
            loading={loading}
            headerHeight={90}
          >
            <Column align="center" width={100} fixed>
              <HeaderCell style={{ marginTop: 20 }}>ลำดับ</HeaderCell>
              {/* <Cell dataKey="rowNum" /> */}
              <Cell>
                {(rowData, index) => {
                  if (rowData.isChild) {
                    return rowData._parent.rowNum + '.' + rowData.rowNum
                  } else {
                    return rowData.rowNum
                  }
                }}
              </Cell>
            </Column>
            <Column width={130}>
              <HeaderCell style={{ marginTop: 20 }}>รหัสโครงการ</HeaderCell>
              {/* <Cell dataKey="projectCode" /> */}
              <Cell>
                {(rowData, index) => {
                  if (rowData.isChild) {
                    return (
                      <div style={{ marginLeft: 30 }}>
                        {isEmpty(rowData.sendDate) && (
                          <Checkbox
                            checked={
                              selected?.projectCode == rowData._parent.projectCode &&
                              selected?.emails?.includes(rowData.assessorEmail)
                            }
                            // onChange={(_, checked) => {
                            //   console.log('Checkbox : ', checked)

                            //   onSelected(rowData, checked)
                            // }}
                          />
                        )}
                      </div>
                    )
                  } else {
                    return rowData.projectCode
                  }
                }}
              </Cell>
            </Column>

            <ColumnGroup header="ชื่อโครงการ" align="center">
              <Column width={250} minWidth={250} colSpan={4} flexGrow={1}>
                <HeaderCell>ผู้ประเมิน</HeaderCell>
                <Cell style={{ textAlign: 'left' }}>
                  {(rowData, index) => {
                    if (rowData.isChild) {
                      return (
                        <>
                          <labe>{rowData.assessor}</labe>
                          <br />
                          <i>( {rowData.assessorEmail} )</i>
                        </>
                      )
                    } else {
                      return rowData.projectName
                    }
                  }}
                </Cell>
              </Column>

              <Column width={230}>
                <HeaderCell>ตำแหน่ง</HeaderCell>
                <Cell style={{ textAlign: 'left' }}>
                  {(rowData, index) => {
                    if (rowData.isChild) {
                      return (
                        <>
                          <labe>{rowData.assessorPosition}</labe>
                        </>
                      )
                    }
                  }}
                </Cell>
              </Column>
              <Column width={180}>
                <HeaderCell>วันที่ส่งแจ้งประเมิน</HeaderCell>
                {/* <Cell dataKey="notiDate" /> */}
                <Cell>
                  {(rowData, index) => {
                    if (rowData.isChild) {
                      if (rowData.notiDate) {
                        let values = rowData.notiDate?.split('(')
                        return (
                          <>
                            <labe>{values[0]}</labe>
                            <br />
                            <labe>({values[1]}</labe>
                          </>
                        )
                      }
                    }
                  }}
                </Cell>
              </Column>
              <Column width={180}>
                <HeaderCell>วันที่ส่งผลประเมิน</HeaderCell>
                <Cell dataKey="sendDate" />
              </Column>
            </ColumnGroup>
            <Column width={200} fixed="right" align="center">
              <HeaderCell></HeaderCell>
              <Cell>
                {(rowData, index) => {
                  return (
                    <>
                      {rowData.isChild ? (
                        <ViewButton
                          style={{
                            marginRight: 10,
                            marginBottom: 10,
                          }}
                          children="แสดง"
                          onClick={() => {
                            sessionStorage.setItem('m_e_s_id', rowData.id)
                            sessionStorage.setItem('project_code', rowData._parent.projectCode)

                            history.push(pathname.assessment.assessmentMAndESelfForm)
                          }}
                        />
                      ) : (
                        <>
                          {!rowData.disabled && (
                            <SaveButton
                              icon="send"
                              children={`ส่งแจ้งประเมิน${
                                selected?.projectCode == rowData.projectCode &&
                                selected?.emails?.length > 0
                                  ? ` (${selected?.emails?.length})`
                                  : ''
                              }`}
                              disabled={selected?.projectCode != rowData.projectCode}
                              onClick={() => {
                                handleSendNoti(selected)
                                // console.log('call send mail ', selected)
                              }}
                            />
                          )}
                        </>
                      )}
                    </>
                  )
                }}
              </Cell>
            </Column>
          </Table>

          <TablePagination
            lengthMenu={defaultLengthMenu}
            activePage={page || defaultPage}
            renderLengthMenu={(lengthMenu) => {
              return (
                <>
                  {lengthMenu}
                  {`รายการ/หน้า`}
                </>
              )
            }}
            renderTotal={(total) => {
              return <>{` ทั้งหมด ${total || 0} รายการ`}</>
            }}
            displayLength={displayLength || 5}
            total={totalSize}
            onChangePage={handleChangePage}
            onChangeLength={handleChangeLength}
          />
        </>
      )}
    </Panel>
  )
}
